import product from "./product/index"


export default product;
